import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-categoria',
  templateUrl: './edit-categoria.component.html',
  styleUrls: ['./edit-categoria.component.scss']
})
export class EditCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
